module.exports = __webpack_public_path__ + "img/56.da2b809f.svg";